/*
 * @Author: chengyu
 * @Date: 2022-08-16 19:32:32
 * @Description: 抹平原生Storage，小程序与Taro小程序的差异
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MpTypeEnum, StorageTypeEnum } from './base';
import { isArray, isObject } from './is';
import StorageBrowser from './storageBrowser';
/**
 * 浏览器环境下，补充Storage方法
 * @param mp
 * @param mpApi
 */
function storageBrowserPolyfill(mp, mpApi) {
    if (mp === MpTypeEnum.browser) {
        var storageBrowser = new StorageBrowser();
        return isObject(mpApi) ? __assign(__assign({}, mpApi), storageBrowser) : storageBrowser;
    }
    return mpApi;
}
var Storage = /** @class */ (function () {
    function Storage(options) {
        this.mp = options.mp;
        this.mpApi = storageBrowserPolyfill(options.mp, options.mpApi);
        this.logger = options.logger;
    }
    /**
     * 抹平入参差异
     * @param type
     * @param key
     * @param value
     */
    Storage.prototype.transformParams = function (type, key, value) {
        if (type === StorageTypeEnum.SET) {
            if (this.mp === MpTypeEnum.taro ||
                this.mp === MpTypeEnum.wechat ||
                this.mp === MpTypeEnum.browser) {
                return [key, value];
            }
            if (this.mp === MpTypeEnum.alipay) {
                return [{ key: key, data: value }];
            }
        }
        if (type === StorageTypeEnum.GET || type === StorageTypeEnum.REMOVE) {
            if (this.mp === MpTypeEnum.taro ||
                this.mp === MpTypeEnum.wechat ||
                this.mp === MpTypeEnum.browser) {
                return [key];
            }
            if (this.mp === MpTypeEnum.alipay) {
                return [{ key: key }];
            }
        }
        return undefined;
    };
    /**
     * 获取本地缓存
     * @param key {string}
     */
    Storage.prototype.getStorageSync = function (key) {
        var _a;
        try {
            var params = this.transformParams(StorageTypeEnum.GET, key);
            if (params) {
                var result = (_a = this.mpApi) === null || _a === void 0 ? void 0 : _a.getStorageSync.apply(_a, params);
                if (this.mp === MpTypeEnum.alipay)
                    return result.data;
                if (this.mp === MpTypeEnum.taro ||
                    this.mp === MpTypeEnum.browser ||
                    this.mp === MpTypeEnum.wechat)
                    return result;
            }
        }
        catch (e) {
            this.logger.error('getStorageSync', e);
        }
        return undefined;
    };
    /**
     * 存储本地缓存
     * alipay https://opendocs.alipay.com/mini/api/cog0du (差异)
     * @param key
     * @param value
     */
    Storage.prototype.setStorageSync = function (key, value) {
        var _a;
        var params = this.transformParams(StorageTypeEnum.SET, key, value);
        if (params)
            (_a = this.mpApi) === null || _a === void 0 ? void 0 : _a.setStorageSync.apply(_a, params);
    };
    /**
     * 删除本地缓存
     * alipay https://opendocs.alipay.com/mini/api/ytfrk4 (差异)
     * @param key {string}
     */
    Storage.prototype.removeStorageSync = function (key) {
        var _a;
        var params = this.transformParams(StorageTypeEnum.REMOVE, key);
        if (params)
            (_a = this.mpApi) === null || _a === void 0 ? void 0 : _a.removeStorageSync.apply(_a, params);
    };
    /**
     * taro: https://docs.taro.zone/docs/apis/storage/getStorageInfoSync
     * alipay: https://opendocs.alipay.com/mini/api/uw5rdl
     */
    Storage.prototype.getStorageInfoSync = function () {
        var _a;
        return (_a = this.mpApi) === null || _a === void 0 ? void 0 : _a.getStorageInfoSync();
    };
    /**
     * 读取当前命名空间下的所有key，并删除
     */
    Storage.prototype.clearStorageSync = function (namespace) {
        var _this = this;
        var deleted = false;
        try {
            var info = this.getStorageInfoSync();
            if (info && isObject(info) && isArray(info.keys)) {
                info.keys.forEach(function (key) {
                    if (key.startsWith(namespace)) {
                        _this.removeStorageSync(key);
                    }
                });
            }
            deleted = true;
        }
        catch (e) {
            this.logger.info("clearStorageSync " + namespace, e);
        }
        return deleted;
    };
    return Storage;
}());
export default Storage;
//# sourceMappingURL=data:application/json;base64,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